import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import Slider from "react-slick";
import ProgressiveImage from "react-progressive-image";

class Coupons extends Component {
    state = {
        quick_bites : [],
    };

    componentDidMount(){
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        axios
        .post('https://pykin.in/public/api/get-active-coupons')
        .then((response) => {
            const quickBites = response.data;
            if (quickBites.length) {
                this.setState({
                    quick_bites: response.data
                });
            } else {
                this.setState({
                    quick_bites: [],
                });
            }
        });
    }

    render() {

		return (
            <React.Fragment >
                {this.state.quick_bites.length > 0 && (
                    
                    <div className="mb-5 mt-5" style={{"fontSize":"large","paddingLeft":"10px","fontWeight":"bold"}}>Explore Coupons</div>
                )}
          <div className="slider-wrapper secondary-slider-wrapper bg-white rounded mt-0 mb-0">
          {this.state.quick_bites.length === 0 ? 

                <ContentLoader 
                    speed={2}
                    width={400}
                    height={50}
                    viewBox="0 0 400 50"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                >
                    <rect x="0" y="60" rx="3" ry="3" width="59" height="8" /> 
                    <circle cx="31" cy="26" r="23" /> 
                    <rect x="67" y="60" rx="3" ry="3" width="59" height="8" /> 
                    <circle cx="99" cy="25" r="23" /> 
                    <rect x="136" y="60" rx="3" ry="3" width="59" height="8" /> 
                    <circle cx="169" cy="25" r="23" /> 
                    <rect x="204" y="60" rx="3" ry="3" width="59" height="8" /> 
                    <circle cx="236" cy="25" r="23" /> 
                    <rect x="271" y="60" rx="3" ry="3" width="59" height="8" /> 
                    <circle cx="303" cy="23" r="23" /> 
                    <rect x="342" y="60" rx="3" ry="3" width="59" height="8" /> 
                    <circle cx="375" cy="23" r="23" />
                </ContentLoader>  : ( this.state.quick_bites.map((quick_bite, index) => (
                <React.Fragment key={quick_bite.id}>
                {quick_bite.image  &&
                <DelayLink
                    to={'/coupon/'+quick_bite.id}
                    delay={200}
                    className="slider-wrapper__img-wrapper "
                    style={{ position: "relative", textAlign: "center",backgroundColor: '#fffff' }}
                >
                    <div className="bg-white rounded">
                       
                    <ProgressiveImage
						delay={100}
                        src={localStorage.getItem('cdn')+quick_bite.image }
						placeholder={'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder'}
					>
						{(src, loading) => (
							    <img className="img-fluid rounded" src={src}  />  

						)}
					</ProgressiveImage>	    
                         
                    </div>
                    
                    <Ink  background={false} />
                </DelayLink>
                }


                </React.Fragment>
                ))) }
                </div>
            </React.Fragment>
        );
    }
}

export default Coupons;
